import type { Message } from '../types/message';
import type { User } from '../types/user';
import { anonIdOf } from '../lib/anon';

// 匿名标签(8 位随机 ID,用于泄露溯源)
export function anonTag(userId?: number | string | null): string {
  if (userId === undefined || userId === null) return '';
  return anonIdOf(userId);
}

// 格式化时间:今天 → HH:mm;昨天 → 昨天;更早 → MM/DD
export function formatTime(iso?: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const startOfDay = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const pad = (n: number) => String(n).padStart(2, '0');
  if (startOfDay === startOfToday) return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  if (startOfDay === startOfToday - 86400000) return '昨天';
  if (d.getFullYear() === now.getFullYear()) return `${pad(d.getMonth() + 1)}/${pad(d.getDate())}`;
  return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())}`;
}

// 完整时间(会话详情/气泡分组)
export function formatFullTime(iso?: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// 会话列表的最近消息预览
export function previewContent(msg?: Message | null): string {
  if (!msg) return '';
  if (msg.deleted) return '消息已撤回';
  return msg.content;
}

// 头像首字符
export function avatarText(user?: Pick<User, 'nickname' | 'username'> | null): string {
  if (!user) return '?';
  return (user.nickname || user.username || '?')[0]?.toUpperCase() || '?';
}
